import { SCORECARDS_CHILD_ROUTE } from "@/constants/routes.constants";
import { redirectToDashboard } from "@/helpers/navigation/navigation.helpers";
import { useBoolean } from "@/hooks/useBoolean/useBoolean";
import { ScorecardPreCreateFormValue } from "../../components/ScorecardPreCreateModal/ScorecardPreCreateModal.decl";
import { useTrackScorecardCreationFunnel } from "../useTrackScorecardCreationFunnel/useTrackScorecardCreationFunnel";

// handles the flow when create scorecard button is clicked, depending on the value of FF
export function useCreateScoreCardFlow() {
  const {
    value: isPreCreateModalOpen,
    setTrue: showModal,
    setFalse: hideModal,
  } = useBoolean();

  const { trackScorecardCreateSelected, trackScorecardCreationStarted } =
    useTrackScorecardCreationFunnel();

  const onCreateButtonClick = () => {
    trackScorecardCreationStarted();
    showModal();
  };

  const onPreCreateFormSubmit = (value: ScorecardPreCreateFormValue) => {
    trackScorecardCreateSelected();

    const params = new URLSearchParams(value);
    redirectToDashboard(`${SCORECARDS_CHILD_ROUTE.NEW}?${params.toString()}`);
  };

  return {
    isPreCreateModalOpen,
    hideModal,
    onPreCreateFormSubmit,
    onCreateButtonClick,
  };
}
